import keyBy from 'lodash/keyBy';

export const REMOVE_TAG_TEXT = 'remove';
export const STAND_BY_TAG = 'Stand-By';
export const LOWER_CASE_STAND_BY = 'stand by';
export const KEYBOARD_KEYS = { ENTER: 'Enter' };
export const chipWidth = '150px';

export enum StandardTag {
  DevTest = 'dev-test',
  CsmTest = 'csm-test',
  ApiEnabled = 'api enabled',
  IsolatedAi = 'isolated-ai',
  SalesTeam = 'sales-team',
  QaTeam = 'qa-team',
  ExternalDevTeam = 'ext-dev-team',
}

export const standardTagsList = [
  {
    name: StandardTag.DevTest,
    label: 'General dev test team',
    value: StandardTag.DevTest,
  },
];

export const teamStandardTagsList = [
  {
    name: StandardTag.CsmTest,
    label: 'CSM test team',
    value: StandardTag.CsmTest,
  },
  {
    name: StandardTag.ExternalDevTeam,
    label: 'External dev team',
    value: StandardTag.ExternalDevTeam,
  },
  {
    name: StandardTag.DevTest,
    label: 'General dev test team',
    value: StandardTag.DevTest,
  },
  {
    name: StandardTag.QaTeam,
    label: 'QA team',
    value: StandardTag.QaTeam,
  },
  {
    name: StandardTag.SalesTeam,
    label: 'Sales team',
    value: StandardTag.SalesTeam,
  },
];

export const realmStandardTagsList = [
  ...standardTagsList,
  {
    name: StandardTag.IsolatedAi,
    label: 'Isolated AI',
    value: StandardTag.IsolatedAi,
  },
];

// Comprehensive list of all standard tags for building the hash
const allStandardTags = [
  ...teamStandardTagsList, // Includes all team tags
  {
    name: StandardTag.IsolatedAi,
    label: 'Isolated AI',
    value: StandardTag.IsolatedAi,
  },
];

export const standardTagsHash = keyBy(allStandardTags, 'value');
